export const text = {
  title: "Title",
  enterTitle: "Enter Title",
  description: "Description",
  enterDescription: "Enter Description",
  code: "Code",
  enterCode: "Enter Code",
  startDate: "Start Date",
  enterStartDate: "Enter Start Date",
  endDate: "End Date",
  enterEndDate: "Enter End Date",
  subscription: "Subscription",
  selectSubscription: "Select Subscription",
  status: "Status",
  enteramount: "Enter Amount",
  amount: "Discount Amount",
  minDiscount: "Minimum Discount",
  maxDiscount: "Maximum Discount",
  deleteCoupon: "You Want To Delete Coupen",
  activeCoupen: "You Want To Active Coupen",
  inActiveCoupen: "You Want To Inactive Coupen",
  limit: "Limit",
  enterLimit: "Enter Limit",
  enterCouponCode: "Enter Coupon Code",
};
